// extracted by mini-css-extract-plugin
module.exports = {"questionGroup":"RatingStar_questionGroup__TozWK"};